import './PwaIos.sass';
import React, { FC } from 'react';

import { useCurrentLang, useTranslator } from '$hooks';
import { ScrollView, Header } from '$uikit';

const images: { [key: string]: string[] } = {
  en: [
    require('./assets/0_en.png').default,
    require('./assets/1_en.png').default,
    require('./assets/2_en.png').default,
    require('./assets/3_en.png').default,
  ],
  ru: [
    require('./assets/0_ru.png').default,
    require('./assets/1_ru.png').default,
    require('./assets/2_ru.png').default,
    require('./assets/3_ru.png').default,
  ],
};

const getImagePath = (lang: string, index: number) => {
  const localeImages = images[lang] || images.en;
  return localeImages[index];
};

export const PwaIos: FC = () => {
  const t = useTranslator();
  const { key: langKey } = useCurrentLang();

  return (
    <>
      <Header showBackButton>{t('pwa_ios_title')}</Header>
      <ScrollView>
        <div className="PwaIos__steps">
          {[0, 1, 2, 3].map((index) => (
            <div key={index} className="PwaIos__step">
              <img
                className="PwaIos__step__img"
                src={getImagePath(langKey, index)}
                alt=""
              />
              <div className="PwaIos__step__title">
                {t(`pwa_ios_step_${index + 1}_title`)}
              </div>
              <div className="PwaIos__step__description">
                {t(`pwa_ios_step_${index + 1}_description`)}
              </div>
            </div>
          ))}
        </div>
      </ScrollView>
    </>
  );
};
